const getCurrencySymbol = (currencyCode: string): string => {
  try {
    const symbol = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value;

    return symbol ?? currencyCode;
  } catch {
    return currencyCode;
  }
};

export default getCurrencySymbol;
